<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle" @click.stop>
    <v-chart
      v-if="showChart && !isEmptyData"
      class="chart"
      :option="getOption"
      :init-options="getInitOptions"
      ref="pie"
      theme="ovilia-green"
      autoresize
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
    />
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import parentMixin from "components/bigScreenComponents/base"
import plugins from "./plugin"
import { hasProperty } from "utils"
import handleChartData from "utils/updateData/chart/handleChartData.js"

export default {
  mixins: [parentMixin, plugins, handleChartData],
  name: "cxPie",
  data() {
    return {
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      eventCallbackList: {
        click: [],
        dblclick: [],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      },
      ifStyle5: false
    }
  },
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      console.log("newVal :>>", newVal)
      if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        this.initOption = this.options.initOptions
      }
      if (newVal.length > 1 && newVal[1].type === "gauge") {
        //饼图5的
        this.ifStyle5 = true
      }else{
        this.ifStyle5 = false
      }
      if(this.options.numberCount){
        this.checkFormatterValue()
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "pie")
    },
    isAutoPlayToolTip(newVal, oldVal) {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    autoPlayToolTipIntervalTime(newVal, oldVal) {
      if (this.isAutoPlayToolTip) {
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      }
    },
    showChart() {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.pie?.setOption(this.getOption)
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      } else {
        this.$refs.pie?.clear()
      }
    },
    "options.chartOption.series.0.label.formatter": function (newVal, oldVal) {
      if(this.ifStyle5){
        this.changeFormatter()
      }
      let formatterTypeNumber = this.options.chartOption.series[0]?.label?.formatterTypeNumber
      if(this.options.numberCount && typeof newVal === "string" && (formatterTypeNumber === 4 || formatterTypeNumber === 5)){
        this.checkFormatterValue()
      }
    }
  },
  mounted() {
    this.refreshFunc()
    this.autoplayTooltip()
    const chartOption = this.options.chartOption
    this.checkFormatterValue()
    if (chartOption?.series?.length === 0) {
      this.hasData = false
    } else if (chartOption?.series?.length > 0) {
      this.hasData = !chartOption?.series.every(item => item.data?.length === 0)
    }
    if (chartOption?.series?.length > 1 && chartOption.series[1].type === "gauge") {
      this.ifStyle5 = true
    } else {
      this.ifStyle5 = false
    }
  },
  destroyed() {
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  },
  methods: {
    /*initPiePlugin(opt) {
      const plugins = [...this.options.chartOption.pluginName].filter(it => it.trim().length)
      plugins.forEach(pluginName => {
        if (hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
          this[pluginName](opt)
        }
      })
    },*/
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.options.isAutoPlayToolTip) {
        return
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.pie?.chart
      let data = this.getOption.series[0].data
      this.autoPlayToolTipTimer = setInterval(() => {
        myChart._api.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.tooltipIndex
        })
        this.tooltipIndex++
        if (this.tooltipIndex > data.length - 1) {
          this.tooltipIndex = 0
        }
      }, this.options.autoPlayToolTipIntervalTime)
    },
    changeFormatter() {
      let data1 = this.options.chartOption.series[0].data
      if(data1.length > 0){
        data1.forEach((item, index)=>{
          if(!item.name && item.tooltip){
            data1[index] = Object.assign({
              label: {
                show: false
              }
            },item)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
